// Module Name
export const name = 'users';

export const typeUsers = {
    GET_USER_FAMILY: `${name}/GET_USER_FAMILY`,
    GET_USER_MAIN_CARD: `${name}/GET_USER_MAIN_CARD`,
    GET_USER_CARDS: `${name}/GET_USER_CARDS`,
    CREATE_MEMBER_FAMILY: `${name}/CREATE_MEMBER_FAMILY`,
    CREATE_COMPANY_GUEST: `${name}/CREATE_COMPANY_GUEST`,
};
